/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkDescriptionDTO
 */
export interface WorkDescriptionDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkDescriptionDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkDescriptionDTO
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDescriptionDTO
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDescriptionDTO
     */
    descriptionType?: string;
}

/**
 * Check if a given object implements the WorkDescriptionDTO interface.
 */
export function instanceOfWorkDescriptionDTO(value: object): value is WorkDescriptionDTO {
    return true;
}

export function WorkDescriptionDTOFromJSON(json: any): WorkDescriptionDTO {
    return WorkDescriptionDTOFromJSONTyped(json, false);
}

export function WorkDescriptionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkDescriptionDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'content': json['content'] == null ? undefined : json['content'],
                  'language': json['language'] == null ? undefined : json['language'],
                  'descriptionType': json['descriptionType'] == null ? undefined : json['descriptionType'],
    };
}

export function WorkDescriptionDTOToJSON(json: any): WorkDescriptionDTO {
    return WorkDescriptionDTOToJSONTyped(json, false);
}

export function WorkDescriptionDTOToJSONTyped(value?: WorkDescriptionDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'content': value['content'],
        'language': value['language'],
        'descriptionType': value['descriptionType'],
    };
}


